<template>
  <!-- 银行账户详情 -->
  <div class="transferList">
    <div class="search">
      <el-form :inline="true" class="searchForm" :model="searchForm" :ref="searchForm">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content " style="padding-bottom: 10px">
              <span>开户银行：</span>
              <span>{{ searchForm.DEPOSIT_BANK }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content " style="padding-bottom: 10px">
              <span>账户号码：</span>
              <span>{{ searchForm.ACCOUNT_NUM }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content " style="padding-bottom: 10px">
              <span>账户类型：</span>
              <span v-if="searchForm.ACCOUNT_TYPE === 1">基本存款账户</span>
              <span v-if="searchForm.ACCOUNT_TYPE === 2">一般存款账户</span>
              <span v-if="searchForm.ACCOUNT_TYPE === 3">临时存款账户</span>
              <span v-if="searchForm.ACCOUNT_TYPE === 4">专用存款账户</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-button size="medium" @click="update()" style="margin-top:8px">余额更新</el-button>
        </el-row>
      </el-form>
      <div class="space"></div>
      <div style="padding: 20px 20px; background: white; border-radius: 3px">
        <el-row>
          <el-col :span="24">
            <el-table :data="tableData" stripe border>
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <!-- <el-table-column prop="UPDATE_TIME" label="日期"  min-width="80"></el-table-column> -->
              <el-table-column prop="BALANCE" label="余额" min-width="80"></el-table-column>
              <el-table-column prop="CHANGE_BALANCE" label="较上次" min-width="80"></el-table-column>
              <el-table-column prop="REPORT_DATE" label="上报日期" min-width="50"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 更新余额模态框 -->
    <el-dialog title="余额更新" :visible.sync="updateVisible" width="30%" center>
      <el-form>
        <el-form-item label="账户余额：" :label-width="formLableWidth">
          <el-input v-model="updateForm.BALANCE" size="small" style="width: 216px"></el-input>
        </el-form-item>
        <el-form-item label="上报日期：" :label-width="formLableWidth">
          <el-date-picker v-model="upTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateVisible = false">取消</el-button>
        <el-button type="primary" @click="subUpdate()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      formLableWidth: '120px',
      searchForm: {},
      tableData: [],
      // 更新余额数据
      updateForm: {},
      updateVisible: false,
      upTime: new Date(),
    };
  },
  computed: {
  },
  methods: {
    // 拉取详情数据
    queryDocument() {
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 4,
        ACCOUNT_NUM: sessionStorage.getItem('ACCOUNT_NUM'),
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.searchForm = result[0];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 拉取流水
    queryType() {
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 5,
        ACCOUNT_NUM: sessionStorage.getItem('ACCOUNT_NUM'),
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result;
        }
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].index = i;
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 更新余额
    update() {
      this.updateForm = this.tableData[0];
      this.updateVisible = true;
    },
    // 更新余额确认
    subUpdate() {
      // eslint-disable-next-line prefer-regex-literals
      const reg = new RegExp('^[0-9]+([.]{1}[0-9]{0,2}){0,1}$');
      if (!this.updateForm.BALANCE.replace(/[^\d]/g, '')) {
        this.$message.show({ text: '余额输入格式错误，请重新输入', type: 'warning' });
        return;
      }
      if (!this.updateForm.BALANCE) {
        this.$message.show({ text: '请输入余额！', type: 'warning' });
        return;
      }
      if (!reg.test(this.updateForm.BALANCE)) {
        this.$message.show({ text: '余额格式错误，请重新输入！', type: 'warning' });
        return;
      }
      if (Number(this.updateForm.BALANCE) > 100000000000) {
        this.$message.show({ text: '余额超出指定范围，请重新输入！', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15063',
        OTYPE: 3,
        ACCOUNT_NUM: sessionStorage.getItem('ACCOUNT_NUM'),
        BALANCE: this.updateForm.BALANCE,
        REPORT_DATE: date(this.upTime, '%F'),
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '更新成功', type: 'success' });
        this.updateVisible = false;
        this.queryType();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
  created() {
    this.queryDocument();
    this.queryType();
  },
};
</script>
<style scoped>
.transferList {
  font-size: 14px;
  color: #606266;
}

.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 40px;
  margin: 0 -20px 0 -20px;
}

.search {
  width: 100%;
}

.searchForm {
  border-radius: 3px;
  background: white;
  padding: 20px 20px 20px;
  margin-top: 10px;
}

.top {
  display: flex;
  justify-content: space-around;
}

.people {
  display: flex;
  justify-content: space-around;
}

.space {
  width: 100%;
  height: 1px;
  background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/bankAccountDetail.vue